// extracted by mini-css-extract-plugin
module.exports = {"iconCallouts":"icon-callouts-module--iconCallouts--1Hiu7","iconCallout":"icon-callouts-module--iconCallout--2X1AM","iconCalloutIcon":"icon-callouts-module--iconCalloutIcon--2amNh"};